export enum EnStockChange {
    entrada = 'Entrada',
    saida = 'Saída',
    movimentacao = 'Transferência'
}
